import BaseModel from '../core/BaseModel';

export default class VoucherLoyaltyModel extends BaseModel {

    constructor() {
        super({
                name: "voucher_loyalty",
                tableName: 'voucher_loyalty',
                label: "Voucher Loyalty",
                display_key: 'voucher_id'  // Hiển thị voucher_id trong bảng
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                loyalty_id: {
                    name: 'loyalty_id',
                    type: "Uuid",
                    label: 'Loyalty ID',
                    width: 20,
                    class: 'left',
                    filter: { type: 'input', match: 'contains' }
                },
                voucher_id: {
                    name: 'voucher_id',
                    type: "Uuid",
                    label: 'Voucher ID',
                    width: 20,
                    class: 'left',
                    filter: { type: 'input', match: 'contains' }
                },
                ordinal: {
                    name: 'ordinal',
                    type: "Number",
                    label: 'Ordinal',
                    width: 10,
                    class: 'right',
                    filter: { type: 'input', match: 'equals' }
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    label: 'Created At',
                    width: 10,
                    class: 'center',
                    filter: { type: 'DateRange', match: 'equals' }
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated At',
                    width: 10,
                    class: 'center',
                    filter: { type: 'DateRange', match: 'equals' }
                },
                updated_by: {
                    name: 'updated_by',
                    type: "Uuid",
                    label: 'Updated By',
                    display: false
                },
                created_by: {
                    name: 'created_by',
                    type: "Uuid",
                    label: 'Created By',
                    display: false
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        { value: 'true', label: 'Yes', style: 'color:  #000000;' },
                        { value: 'false', label: 'No', style: 'color:  #000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: "center",
                    width: 8,
                },
                deleted: {
                    name: "deleted",
                    type: "Boolean",
                    label: "Deleted",
                    display: false
                }
            })
    }
}
